import { Component, OnInit, Input, Output, EventEmitter,ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';

//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { Zona } from '../Models/Zona';
import { ZonaService } from '../services/zona.service';
import { GlobalsService } from '../services/globals.service';

@Component({
  selector: 'app-zona',
  templateUrl: './zona.component.html',
  styleUrls: ['./zona.component.css']
})
export class ZonaComponent implements OnInit {


  public zona: Zona = new Zona();
  public zonas: Zona[];

  public modoEdicion: boolean = false;
  public nuevoRegistro: boolean = false;

//grid
@ViewChild('agGrid') agGrid: AgGridNg2;
 title = 'Vehiculos';

 columnDefs = [
    //  {headerName: 'Identificador', field: 'idZona' },
     {headerName: 'Descripción', field: 'descripcion' ,icons:{ filter: ' '} },
    
   
 ];

 rowData: any[];


  constructor(private zonaService: ZonaService, private globalServices: GlobalsService) {

  }

  ngOnInit() {

    this.modoEdicion = false;

    this.CargarZonas();

  }


  CargarZonas() {

    try {

      this.zonaService.ObtenerZonas(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.zonas = data;
          this.rowData=this.zonas;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("Cargarzonas: " + error);
    }
  }



  GuardarRegistro() {

    this.zona.idcompania = this.globalServices.ObtenerCompania();

    this.zonaService.GuardarRegistro(this.zona).subscribe(

      result => {

        swal("Registro guardado con éxito!", "", "success");

        this.zona = new Zona();
        this.modoEdicion = false;

        this.CargarZonas();
      },
      err => {
        console.log(err._body);
      });


  }

  NuevoRegistro() {
    this.nuevoRegistro = true;
    this.zona = new Zona();
    this.modoEdicion = true;
  }

  CancelarEdicion() {
    this.zona = new Zona();
    this.modoEdicion = false;
  }


  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field); 
    let row= $event.rowIndex;
    let datos=JSON.parse(JSON.stringify($event.data));  

    this.nuevoRegistro = false;
    this.zona = datos;
    this.modoEdicion = true;

  }


}
